import { render, staticRenderFns } from "./DesignOppositionBasisForOppositionForm.vue?vue&type=template&id=18a71dae&"
import script from "./DesignOppositionBasisForOppositionForm.vue?vue&type=script&lang=js&"
export * from "./DesignOppositionBasisForOppositionForm.vue?vue&type=script&lang=js&"
import style0 from "./DesignOppositionBasisForOppositionForm.vue?vue&type=style&index=0&id=18a71dae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports